import {
  mdiPlus,
  mdiClose,
  mdiArrowTopRight,
  mdiHistory,
  mdiFilterVariant,
  mdiChevronDown,
  mdiChevronRight,
} from "@mdi/js";
import Icon from "@mdi/react";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../ui/new_components/common/drawer_modal";
import EntityHistory, {
  GetMasterLogsByEntityApi,
} from "../../purchase_order/purchase_order_create/components/entity_logs";
import {
  Fragment,
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import LoadingWidget from "../../../context_providers/modal/loader";
import {
  useToast,
  ToastType,
} from "../../../context_providers/toast/toast_ctx";
import { fetchGet, toQueryString } from "../../../service/api_client";
import { urls } from "../../../utils/urls";
import { useAuth } from "../../../context_providers/auth/authProvider";
import { ACTION, MODULE } from "../../../utils/enums";
import Pagination from "../../../ui/new_components/common/pagination";
import { debounce } from "lodash";
import {
  CostCenter,
  CostCenterCloseStatus,
  CostCenterFilterData,
  MasterCostCenterStatus,
} from "../models/cost_center_model";
import { Project } from "../models/project_model";
import moment from "moment";
import SearchFieldWidget from "../../../ui/new_components/search_field";
import FilterDropDown from "../../../ui/new_components/common/filter_drop_down";
import LinkedProjectsTable from "./components/linked_projects_table";
import { formatAmountWithCommas } from "../../../ui/pages/content_panel/utils/helpers";
import {
  ResponsiveListShell,
  FilterSheet,
  DateRangeFilter,
  MobileRecordCard,
  MobileRecordCardList,
  StatusBadge,
  EmptyState,
} from "../../../ui/new_components/common/responsive";

interface CostCenterScreenProps {}

const defaultFilter: CostCenterFilterData = {
  page: 1,
  count: 100,
};

const COST_CENTER_TABLE_COLUMNS = 20;

const CostCenterListScreen: FunctionComponent<CostCenterScreenProps> = () => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/cost_center`;
  const [filter, setFilter] = useState<CostCenterFilterData>(defaultFilter);
  const { showToast } = useToast();
  const [checker, setChecker] = useState(false);
  const [maker, setMaker] = useState(false);
  const [showHistory, setShowHistory] = useState<any>();
  const [selectedItems, setSelectedItems] = useState<CostCenter[]>([]);
  const [showImportErrors, setShowImportErrors] = useState<boolean>(false);
  const [errorObjectList, setErrorObjectList] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(50);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState<CostCenter[]>([]);
  const [expandedCC, setExpandedCC] = useState<string[]>([]);
  // Visible width of the table's scroll box, so an expanded linked-projects
  // panel fits the screen instead of stretching to the full table width.
  const tableScrollRef = useRef<HTMLDivElement>(null);
  const [tableViewportWidth, setTableViewportWidth] = useState<number>();
  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;
    const observer = new ResizeObserver(() =>
      setTableViewportWidth(el.clientWidth),
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [data.length > 0]);
  const toggleExpanded = (ccId: string) =>
    setExpandedCC((prev) =>
      prev.includes(ccId) ? prev.filter((id) => id !== ccId) : [...prev, ccId],
    );
  const [updateDisabled, setUpdateDisabled] = useState(true);
  const [showFilter, setShowFilter] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= 768,
  );
  const { isAuthorised } = useAuth();

  useEffect(() => {
    const disable = selectedItems.length === 0;

    setUpdateDisabled(disable);
  }, [selectedItems]);

  // A backend that predates linked_projects_count leaves it undefined; count
  // the links from Project Master here instead of showing 0.
  const withLinkedProjectCounts = async (
    rows: CostCenter[],
  ): Promise<CostCenter[]> => {
    if (rows.every((r) => typeof r.linked_projects_count === "number"))
      return rows;
    const res = await fetchGet(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/project` +
        toQueryString({ all: true }),
    );
    if (!res.success) return rows;
    const counts: Record<string, number> = {};
    for (const p of (res.data?.data ?? []) as Project[]) {
      if (p.cost_center_id)
        counts[p.cost_center_id] = (counts[p.cost_center_id] ?? 0) + 1;
    }
    return rows.map((r) => ({
      ...r,
      linked_projects_count: r.linked_projects_count ?? counts[r.id] ?? 0,
    }));
  };

  const fetchData = async (prop: CostCenterFilterData) => {
    setLoading(true);
    try {
      const res = await fetchGet(url + toQueryString(prop));
      if (res.success) {
        setData(await withLinkedProjectCounts(res.data.data ?? []));
        setCount(res.data.metadata?.count);

        if (res.data.metadata) {
          setTotal(res.data.metadata.total);
        }
        setLoading(false);
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  useEffect(() => {
    const maker_permission_result = isAuthorised({
      module: MODULE.cost_center,
      action: ACTION.CREATE,
    });
    const checker_permission_result = isAuthorised({
      module: MODULE.cost_center_approval_L1 || MODULE.cost_center_approval_L2,
      action: ACTION.UPDATE,
    });
    setChecker(checker_permission_result);
    setMaker(maker_permission_result);
  }, [isAuthorised]);

  const debouncedHandler = useCallback(
    debounce((prop: CostCenterFilterData) => {
      if (prop) fetchData(prop);
    }, 500),
    [],
  );

  useEffect(() => {
    debouncedHandler(filter);
  }, [page, filter, debouncedHandler]);

  const getCostCenterListData = async () => {
    try {
      const a = document.createElement("a");
      a.target = "_blank";
      console.log("filter:", filter);
      a.href = `${
        process.env.REACT_APP_BACKEND_BASE_URL
      }/api/v3/erp/inventory/cost_center/export${toQueryString({
        query: JSON.stringify({
          ...filter,
        }),
      })}`;

      // Delay the trigger to allow UI updates (if necessary)
      setTimeout(() => {
        setLoading(false);
        showToast({ type: ToastType.success, text: "Download started!" });
        a.click(); // Trigger the download
      }, 1000);
    } catch (error) {
      setLoading(false); // Make sure loading is set to false in case of an error
      showToast({ type: ToastType.error, text: "Failed to start download." });
      console.error("Download error:", error);
    }
  };

  const navaigation = useHistory();
  const onSelect = (d: CostCenter) => {
    if (
      checker &&
      (d.costCenterStatus === MasterCostCenterStatus.approved ||
        d.costCenterStatus === MasterCostCenterStatus.rejected)
    ) {
      navaigation.push(
        urls.procurement_masters_cost_center + "/view-cost-center/" + d.id,
      );
    } else if (
      maker &&
      d.costCenterStatus === MasterCostCenterStatus.pendingForApproval
    ) {
      navaigation.push(
        urls.procurement_masters_cost_center + "/view-cost-center/" + d!.id,
      );
    } else {
      navaigation.push(
        urls.procurement_masters_cost_center + "/view-cost-center/" + d.id,
      );
    }
  };

  const handleOnEdit = () => {
    if (selectedItems.length > 1) {
      showToast({
        type: ToastType.error,
        text: "Please select one item to edit",
      });
    } else if (selectedItems.length === 0) {
      showToast({
        type: ToastType.error,
        text: "Please select an item to edit",
      });
    } else {
      navaigation.push(
        urls.procurement_masters_cost_center +
          "/update/" +
          selectedItems[0]!.id,
      );
    }
  };

  return (
    <>
      {showHistory && (
        <DrawerModal
          location={DrawerModalLoaction.right}
          show={showHistory !== undefined}
          onClose={() => setShowHistory(undefined)}
          title="Cost Center History"
        >
          <EntityHistory
            fetchLogs={({ page, count }) =>
              GetMasterLogsByEntityApi({
                entityType: "cost center",
                entityId: showHistory,
                page,
                count,
              })
            }
          />
        </DrawerModal>
      )}

      <ResponsiveListShell
        title="Cost Center Master"
        count={total}
        onRefresh={() => fetchData({ page, count })}
        search={
          <div id="cost_center_id_search" className="flex flex-col gap-1">
            <SearchFieldWidget
              placeholder="Cost Center ID"
              defaulValue={filter?.id}
              onClear={() => {
                setFilter({ ...filter, id: undefined });
                setPage(1);
              }}
              onSubmit={(val) => {
                setFilter({ ...filter, id: val });
                setPage(1);
              }}
            />
          </div>
        }
        actions={
          <>
            <button
              id="export_btn"
              onClick={() => {
                getCostCenterListData();
              }}
              className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
            >
              <Icon path={mdiArrowTopRight} className="h-4 w-4" />
              Export
            </button>

            {maker && (
              <button
                id="create_btn"
                onClick={() => {
                  navaigation.push(
                    urls.procurement_masters_cost_center + "/create",
                  );
                }}
                className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
              >
                <Icon path={mdiPlus} className="h-4 w-4" />
                Create
              </button>
            )}

            {maker && (
              <button
                id="update_btn"
                onClick={handleOnEdit}
                disabled={updateDisabled}
                className={`flex gap-1 items-center rounded p-1 bg-myPrimaryColor text-white transform duration-200 text-xs ${
                  updateDisabled
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer hover:scale-105"
                }`}
              >
                <Icon path={mdiPlus} className="w-4 h-4" />
                Update
              </button>
            )}
          </>
        }
        filterToggle={
          <div className="flex gap-2 items-center">
            <h6 className="font-normal text-xs">Filters</h6>
            <div
              id="cost_center_list_filter_toggle_btn"
              onClick={() => setShowFilter((v) => !v)}
              className="flex items-center justify-center bg-gray-200 p-1 rounded-full hover:bg-gray-800 hover:text-white cursor-pointer"
            >
              <Icon path={mdiFilterVariant} className="w-4 h-4" />
            </div>
          </div>
        }
      >
        <FilterSheet
          show={showFilter}
          onClose={() => setShowFilter(false)}
          onApply={() => setShowFilter(false)}
          onReset={() => setFilter(defaultFilter)}
          gridClassName="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-2 items-start"
        >
          <div id="cost_center_period_filter">
            <label>Period</label>
            <DateRangeFilter
              compact
              showChips={false}
              fromLabel="From"
              toLabel="To"
              fromDate={
                filter.fromMonth
                  ? moment(filter?.fromMonth).format("YYYY-MM-DD")
                  : ""
              }
              toDate={
                filter.toMonth
                  ? moment(filter?.toMonth).format("YYYY-MM-DD")
                  : ""
              }
              onFromChange={(v) =>
                setFilter({
                  ...filter,
                  fromMonth: v
                    ? new Date(new Date(v).setHours(0, 0, 0, 0))
                    : undefined,
                })
              }
              onToChange={(v) =>
                setFilter({
                  ...filter,
                  toMonth: v
                    ? new Date(new Date(v).setHours(0, 0, 0, 0))
                    : undefined,
                })
              }
            />
          </div>
          <div>
            <label>Cost Center Name</label>
            <SearchFieldWidget
              defaulValue={filter?.name}
              onClear={() => {
                setFilter({ ...filter, name: undefined });
                setPage(1);
              }}
              onSubmit={(val) => {
                setFilter({ ...filter, name: val });
                setPage(1);
              }}
            />
          </div>
          <div>
            <label className="text-md">Approval Status</label>
            <FilterDropDown
              placeholder="Approval Status"
              onClearAll={() =>
                setFilter({ ...filter, approvalStatus: undefined })
              }
              onDelete={(type) => {
                setFilter({
                  ...filter,
                  approvalStatus: filter?.approvalStatus?.filter(
                    (f: any) => f !== type,
                  ),
                });
              }}
              onSelect={(type) => {
                setFilter((old) => ({
                  ...old,
                  approvalStatus: [...(old?.approvalStatus ?? []), type],
                }));
              }}
              selectedOptions={filter?.approvalStatus ?? []}
              options={Object.values(MasterCostCenterStatus).map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
          <div>
            <label className="text-md">Cost Center Status</label>
            <FilterDropDown
              placeholder="CC Status"
              onClearAll={() =>
                setFilter({ ...filter, costCenterStatus: undefined })
              }
              onDelete={(type) => {
                setFilter({
                  ...filter,
                  costCenterStatus: filter?.costCenterStatus?.filter(
                    (f: any) => f !== type,
                  ),
                });
              }}
              onSelect={(type) => {
                setFilter((old) => ({
                  ...old,
                  costCenterStatus: [...(old?.costCenterStatus ?? []), type],
                }));
              }}
              selectedOptions={filter?.costCenterStatus ?? []}
              options={Object.values(CostCenterCloseStatus).map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
        </FilterSheet>

        {showImportErrors && errorObjectList.length > 0 && (
          <div className="rounded-lg border border-red-800 m-2 px-4 py-3">
            <div className="flex justify-between">
              <div
                id="dismiss_import_errors_btn"
                onClick={() => {
                  setShowImportErrors(false);
                }}
                className="mt-4 bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded"
              >
                <Icon path={mdiClose} className="h-4 w-4"></Icon>
              </div>
            </div>
          </div>
        )}

        {data.length > 0 ? (
          <>
            <div className="hidden md:block my-2 border">
              <div ref={tableScrollRef} className="overflow-auto">
                <table
                  id="cost_center_list_table"
                  className="w-full text-xs divide-y divide-gray-200 relative"
                >
                  <thead className="text-xs py-2 bg-white z-10">
                    <tr className="border">
                      <th>
                        <div className="">
                          <input
                            type="checkbox"
                            name=""
                            id=""
                            checked={
                              selectedItems.length === data.length
                                ? true
                                : false
                            }
                            disabled={checker && !maker ? false : true}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedItems([...data]);
                              } else {
                                setSelectedItems([]);
                              }
                            }}
                          />
                        </div>
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-center">
                        History
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-center">
                        Linked Projects
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Cost Center ID
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Name
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Created At
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        From Month
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        To Month
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Period
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        Budget
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        Additional Funds
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        Total Budget
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        Spent
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        Balance
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-right">
                        Last Approved Budget
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Approved Status
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Cost Center Status
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Created By
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Last Approved By
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Remarks
                      </th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {data.map((cost, i) => {
                      const isSelected = selectedItems.includes(cost);
                      const isExpanded = expandedCC.includes(cost.id);
                      return (
                        <Fragment key={i}>
                          <tr
                            className="border text-center "
                            id={`cost_center_row_${cost.id}`}
                          >
                            <td>
                              <div className="p-2">
                                <input
                                  type="checkbox"
                                  name=""
                                  id=""
                                  checked={isSelected}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedItems((prev) => [
                                        ...prev,
                                        cost,
                                      ]);
                                    } else {
                                      setSelectedItems((prev) =>
                                        prev.filter(
                                          (selectedItem) =>
                                            selectedItem !== cost,
                                        ),
                                      );
                                    }
                                  }}
                                />
                              </div>
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-center">
                              <div
                                id={`cost_center_history_btn_${cost.id}`}
                                className="cursor-pointer flex justify-center"
                                title="History"
                                onClick={() => setShowHistory(cost.id)}
                              >
                                <Icon path={mdiHistory} size="16"></Icon>
                              </div>
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-center">
                              <button
                                type="button"
                                id={`cost_center_linked_projects_${cost.id}`}
                                className="inline-flex items-center gap-1 text-blue-600 hover:underline"
                                title={
                                  isExpanded
                                    ? "Hide linked projects"
                                    : "Show linked projects"
                                }
                                onClick={() => toggleExpanded(cost.id)}
                              >
                                <Icon
                                  path={
                                    isExpanded
                                      ? mdiChevronDown
                                      : mdiChevronRight
                                  }
                                  size={0.7}
                                />
                                {cost.linked_projects_count ?? 0}
                              </button>
                            </td>
                            <td
                              id={`cost_center_view_link_${cost.id}`}
                              className="px-3 py-3 whitespace-nowrap text-left cursor-pointer text-blue-600 hover:underline"
                              role="button"
                              onClick={() => onSelect(cost)}
                            >
                              {cost.id}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-left">
                              {cost.name}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-left">
                              {moment(cost.created_at).format("DD-MM-YYYY")}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap  text-left">
                              {cost?.fromMonth
                                ? moment(cost?.fromMonth).format("DD-MM-YYYY")
                                : ""}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-left">
                              {cost?.toMonth
                                ? moment(cost?.toMonth).format("DD-MM-YYYY")
                                : ""}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-right">
                              {formatAmountWithCommas(cost.period) ?? 0}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-right">
                              {formatAmountWithCommas(cost.budget) ?? 0}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-right">
                              {formatAmountWithCommas(
                                cost.totalAdditionalFunds,
                              ) ?? 0}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-right">
                              {formatAmountWithCommas(cost.totalBudget) ?? 0}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-right">
                              {formatAmountWithCommas(cost.spent) ?? 0}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-right">
                              {formatAmountWithCommas(
                                cost?.lastApprovedBudget - cost?.spent,
                              )}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-right">
                              {formatAmountWithCommas(
                                cost.lastApprovedBudget,
                              ) ?? 0}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-left">
                              <StatusBadge
                                status={cost.approvalStatus}
                                kind="generic"
                              />
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-left">
                              <StatusBadge
                                status={cost.costCenterStatus}
                                kind="generic"
                              />
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-left">
                              {cost.created_by_name ?? "--"}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-left">
                              {cost.approved_by_name ?? "--"}
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-left">
                              {cost.remarks ?? "--"}
                            </td>
                          </tr>
                          {isExpanded && (
                            <tr
                              id={`cost_center_linked_projects_row_${cost.id}`}
                            >
                              <td
                                colSpan={COST_CENTER_TABLE_COLUMNS}
                                className="p-0"
                              >
                                <div
                                  className="sticky left-0 bg-gray-50 border-b px-4 py-3"
                                  style={{ width: tableViewportWidth }}
                                >
                                  <LinkedProjectsTable costCenterId={cost.id} />
                                </div>
                              </td>
                            </tr>
                          )}
                        </Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <MobileRecordCardList>
              {data.map((cost, i) => (
                <Fragment key={i}>
                  <MobileRecordCard
                    id={`cost_center_row_mobile_${cost.id}`}
                    onClick={() => onSelect(cost)}
                    title={cost.id}
                    status={
                      <StatusBadge
                        status={cost.costCenterStatus}
                        kind="generic"
                      />
                    }
                    subStatus={
                      <StatusBadge
                        status={cost.approvalStatus}
                        kind="generic"
                      />
                    }
                    fields={[
                      { label: "Name", value: cost.name },
                      {
                        label: "Linked Projects",
                        value: cost.linked_projects_count ?? 0,
                      },
                      {
                        label: "Total Budget",
                        value: formatAmountWithCommas(cost.totalBudget) ?? 0,
                      },
                      {
                        label: "Spent",
                        value: formatAmountWithCommas(cost.spent) ?? 0,
                      },
                      {
                        label: "Created At",
                        value: moment(cost.created_at).format("DD-MM-YYYY"),
                      },
                      {
                        label: "Created By",
                        value: cost.created_by_name ?? "-",
                      },
                    ]}
                    actions={[
                      {
                        icon: expandedCC.includes(cost.id)
                          ? mdiChevronDown
                          : mdiChevronRight,
                        title: "Linked projects",
                        onClick: () => toggleExpanded(cost.id),
                      },
                      {
                        icon: mdiHistory,
                        title: "History",
                        onClick: () => setShowHistory(cost.id),
                      },
                    ]}
                  />
                  {expandedCC.includes(cost.id) && (
                    <div className="bg-gray-50 border rounded-md p-3 -mt-1">
                      <LinkedProjectsTable costCenterId={cost.id} />
                    </div>
                  )}
                </Fragment>
              ))}
            </MobileRecordCardList>

            <div
              id="cost_center_list_pagination"
              className="mt-3 sticky bottom-0 bg-white z-10 border-t flex justify-between items-center px-4 py-2"
            >
              <Pagination
                itemCount={count}
                page={filter?.page}
                total={total}
                count={filter?.count}
                onChange={(page) => setFilter((o) => ({ ...o, page }))}
              />
            </div>
          </>
        ) : !loading ? (
          <EmptyState
            title="No Cost Centers found!"
            message="Try adjusting your search or filters."
            imageSrc="/images/nodata.png"
          />
        ) : null}
      </ResponsiveListShell>

      {loading && <LoadingWidget></LoadingWidget>}
    </>
  );
};

export default CostCenterListScreen;
